import SimpleTooltip from '@rio-cloud/rio-uikit/components/tooltip/SimpleTooltip';
import NoData from '@rio-cloud/rio-uikit/NoData';
import { PLACEMENT } from '@rio-cloud/rio-uikit/values/Placement';

import type { CardOrdersResponseType } from '@/api/schema';
import { t } from '@/lib/utils';

export type OrderBodyProps = {
    order: CardOrdersResponseType;
    locale: string;
};

export const OrderStatus = {
    RECEIVED: {
        id: 0,
        value: 'orderHistory.orderStatus.orderCreated.label',
        tooltip: 'orderHistory.orderStatus.orderCreated.tooltip',
        icon: 'icon-tasks',
    },
    PLACED: {
        id: 1,
        value: 'orderHistory.orderStatus.inProduction.label',
        tooltip: 'orderHistory.orderStatus.inProduction.tooltip',
        icon: 'icon-conveyor-belt',
    },
    SHIPPED: {
        id: 2,
        value: 'orderHistory.orderStatus.shipped.label',
        tooltip: 'orderHistory.orderStatus.shipped.tooltip',
        icon: 'icon-delivery-on-track',
    },
};

const OrderBody = ({ order, locale }: OrderBodyProps) => (
    <div className='display-flex justify-content-between'>
        <div className='display-flex flex-basis-20pct'>
            <div className='display-flex flex-column gap-2'>
                <span className='text-medium'>{t('orderHistory.orderedBy')}</span>
                <span>
                    {order.user ? (
                        `${order.user.firstName} ${order.user.lastName}`
                    ) : (
                        <NoData text={t('general.notAvailable')} />
                    )}
                </span>
            </div>
        </div>
        <div className='display-flex flex-basis-20pct'>
            <div className='display-flex flex-column gap-2'>
                <span className='text-medium'>{t('orderHistory.orderDate')}</span>
                <span>{new Date(order.orderDate).toLocaleDateString(locale)}</span>
            </div>
        </div>
        <div className='display-flex flex-basis-20pct'>
            <div className='display-flex flex-column gap-2'>
                <span className='text-medium'>{t('orderHistory.cards')}</span>
                <span>{order.cards.length}</span>
            </div>
        </div>
        <div className='display-flex flex-basis-20pct'>
            <div className='display-flex flex-column gap-2'>
                <span className='text-medium'>{t('orderHistory.shippingTo')}</span>
                <span>{order.address.city}</span>
            </div>
        </div>
        <div className='display-flex flex-basis-20pct'>
            <div className='display-flex flex-column gap-2'>
                <span className='text-medium'>
                    {t('orderHistory.orderStatus')}
                    <SimpleTooltip
                        content={t(OrderStatus[order.cardStatus as keyof typeof OrderStatus].tooltip)}
                        placement={PLACEMENT.TOP_START}
                    >
                        <span className='uikit-icon icon-info-sign text-color-light text-size-16 padding-left-2' />
                    </SimpleTooltip>
                </span>
                <div className='label label-default'>
                    <span
                        className={`uikit-icon ${OrderStatus[order.cardStatus as keyof typeof OrderStatus].icon} text-size-14`}
                    />
                    <span>{t(OrderStatus[order.cardStatus as keyof typeof OrderStatus].value)}</span>
                </div>
            </div>
        </div>
        <div className='flex-basis-5pct' />
    </div>
);

export default OrderBody;
